import { FC } from 'react';
import { Typography } from 'antd';

import { SubInfo } from '../SubInfo';
import { CallbackRequest } from '../CallbackRequest';
import { TaskStatus } from '../../../../modules/business-logic/Task/taskStatus';
import { TaskStatusData } from '../../../../modules/api-client/services/v1/TaskService/interfaces';

import styles from '../../styles.module.css';

const { Text, Title } = Typography;

interface Props {
    taskId: string | null;
    name: string;
    statusData: TaskStatusData;
    dateTime: string | undefined;
    timezone: string | undefined;
}

export const TaskCard: FC<Props> = ({ taskId, name, statusData, dateTime, timezone }) => {
    const isCanceled = statusData.value === TaskStatus.CANCELED;

    return (
        <>
            <div className={styles.cardHeader}>
                <Text className={styles.taskId}>ID {taskId}</Text>
                <Title className={styles.taskTitle}>{name}</Title>
            </div>

            <div className={styles.divider} />

            <div className={styles.statuses}>
                <SubInfo title={'Статус'} value={statusData.name || 'Нет данных'} />

                <SubInfo
                    title={'Прибытие исполнителя'}
                    value={dateTime || 'Не указано'}
                    addedValue={timezone}
                />
            </div>

            {taskId && <CallbackRequest taskId={Number(taskId)} isCanceled={isCanceled} />}
        </>
    );
};
